import React from "react";
import { useParams } from "react-router-dom";
// import LandingPage from "./LandingPage";
import FullWidthCenteredLayout from "../../components/FullWidthCenteredLayout/FullWidthCenteredLayout";
// import MpWithSidebarLayout from "../../components/MpWithSidebarLayout/MpWithSidebarLayout";
import ErrorPage from "../ErrorPage/ErrorPage";
// import LandingDefault from "./components/LandingDefault";
import LandingMicrosite from "./components/LandingMicrosite";
import LandingMemberPortal from "./components/LandingMemberPortal";
import SurveyPage from "../Survey/Survey";
import Agreement from "pages/Agreement/Agreement";
import Language from "pages/Language/Language";
import ThankYou from "pages/ThankYou/ThankYou";
import AddressVerificatoin from "pages/AddressVerification/AddressVerification";
import SurveyMemberPortal from "pages/Survey/SurevyMemberPortal";
import MemberPortalAgreement from "pages/MemberPortalAgreement/MemberPortalAgreement";
import MemberPortalThankYou from "pages/MemberPortalThankYou/MemberPortalThankYou";
import AuthB2C from "pages/Auth/components/AuthB2C";
import AuthPageLayout from "pages/Auth/AuthPageLayout";
import ProfilePage from "pages/ProfilePage/ProfilePage";
import PregnancyWeightCalculator from "pages/PregnancyWeightCalculator/PregnancyWeightCalculator";
import UnAuthorisedPage from "pages/UnAuthorisedPage/UnAuthorisedPage";
import RuleBasedThankYou from "pages/ThankYou/RuleBasedThankyou";
import MediCard from "pages/MediCard/MediCard";
import Video from "pages/Video/Video";
// import AppointmentSchedule from "pages/Appointment/components/AppointmentSchedule";
import AppointmentRequest from "pages/AppointmentRequest/AppointmentRequest";

const LandingMicrositeWrapper = ({ target, auth }: any) => {
  const { URL_REF } = useParams();
  const sanitizedTarget =
    typeof target === "string"
      ? target
      : target && typeof target === "object"
        ? target.target
        : "";
  return <LandingMicrosite target={sanitizedTarget} auth={auth} urlRef={URL_REF} />;
};

const LandingPageRoutes = {
  path: "/",
  element: <FullWidthCenteredLayout />,
  children: [
    { path: "", element: <LandingMemberPortal /> },
    { path: "memberlogin", element: <LandingMemberPortal /> },
    { path: "error", element: <ErrorPage /> },
    { path: "s", element: <ErrorPage /> },
    { path: "av", element: <ErrorPage /> },
    { path: "mid", element: <ErrorPage /> },
    { path: "ar", element: <ErrorPage /> },
    {
      path: "s/:URL_REF",
      element: <LandingMicrositeWrapper target="agreement" />,
      errorElement: <ErrorPage />,
    },
    {
      path: "a/:URL_REF",
      element: <LandingMicrositeWrapper target="survey" auth="ANONYMOUS" />,
      errorElement: <ErrorPage />,
    },
    {
      path: "c/:URL_REF",
      element: (
        <LandingMicrositeWrapper
          target="appointment/call-schedule"
          auth="2FA"
        />
      ),
      errorElement: <ErrorPage />,
    },
    {
      path: "av/:URL_REF",
      element: <LandingMicrositeWrapper target="profile" />,
      errorElement: <ErrorPage />,
    },
    {
      path: "ar/:URL_REF",
      element: <LandingMicrositeWrapper target="appointmentrequest" />,
      errorElement: <ErrorPage />,
    },
    {
      path: "mid/:URL_REF",
      element: <LandingMicrositeWrapper target="medicard" />,
      errorElement: <ErrorPage />,
    },
    { path: "survey", element: <SurveyPage />, errorElement: <ErrorPage /> },
    { path: "language", element: <Language />, errorElement: <ErrorPage /> },
    { path: "agreement", element: <Agreement />, errorElement: <ErrorPage /> },
    { path: "thankyou", element: <ThankYou />, errorElement: <ErrorPage /> },
    { path: "profile", element: <ProfilePage />, errorElement: <ErrorPage /> },
    { path: "medicard", element: <MediCard />, errorElement: <ErrorPage /> },
    // { path: "appointment/call-schedule", element: <AppointmentSchedule />, errorElement: <ErrorPage /> },
    {path: "appointmentrequest", element: <AppointmentRequest />, errorElement: <ErrorPage />},
    {
      path: "memberportalthankyou",
      element: <MemberPortalThankYou />,
      errorElement: <ErrorPage />,
    },

    {
      path: "addressverification",
      element: <AddressVerificatoin />,
      errorElement: <ErrorPage />,
    },
    {
      path: "surveymemberportal",
      element: <SurveyMemberPortal />,
      errorElement: <ErrorPage />,
    },
    {
      path: "memberportalagreement",
      element: <MemberPortalAgreement />,
      errorElement: <ErrorPage />,
    },
    {
      path: "preganancyweightcalculator",
      element: <PregnancyWeightCalculator />,
      errorElement: <ErrorPage />,
    },
    {
      path: "callback/auth",
      element: <AuthPageLayout />,
      children: [{ path: "b2c", element: <AuthB2C /> }],
    },
    {
      path: "callback/b2c",
      element: <AuthB2C />,
      // children: [{ path: "b2c", element: <AuthB2C /> }],
    },

    {
      path: "unauthorised",
      element: <UnAuthorisedPage />,
      errorElement: <ErrorPage />,
    },
    {
      path: "thankyourulebased",
      element: <RuleBasedThankYou />,
      errorElement: <ErrorPage />,
    },
    {
      path: "videoCampaign/:campaignName/:userRegistrationCode",
      element: <Video />,
      errorElement: <ErrorPage />,
    },
    { path: "*", element: <ErrorPage />, errorElement: <ErrorPage /> },
  ],
};

export default LandingPageRoutes;
